exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/**\n * Variables\n */\n\n/**\n * Functions\n */\n.progress-bar[data-v-1e708b4a] {\n\tbackground-color: var(--progress-bar-default-color, #dcdbe1);\n\tborder-radius: 0.25rem;\n\theight: 8px;\n\theight: 0.5rem;\n\twidth: 100%;\n}\n.progress-bar .progress[data-v-1e708b4a] {\n\tbackground-color: var(--progress-bar-progress-color, #21ac69);\n\tborder-radius: 0.25rem;\n\theight: 100%;\n\tmax-width: 100%;\n\tmin-width: 8px;\n\tmin-width: 0.5rem;\n\ttransition: width 0.1s ease;\n}\n", ""]);

// exports
